var app = angular.module('tf.leagues.search', [])
    .controller('leagueSearchCtrl', leagueSearchCtrl);

/** ngInject */
function leagueSearchCtrl($scope, $http, leaderBoardService, $timeout, $state) {

    $scope.leagueFilter = '';
    $scope.leagues = [];

    $scope.retrievePublicLeagues = function () {
        $http.get('/tradefloor/api/leaderboards/public')
            .then(showPublicLeagues, retrieveError);
    };

    $scope.joinLeague = function (league) {
        leaderBoardService.joinLeague(league.name).then(function() {
            $state.go('leagues', {board: league.id})
        });
    };

    $scope.retrievePublicLeagues();

    function showPublicLeagues(response) {
        var data = response.data;
        $scope.leagues = data;
    }

    function retrieveError() {
        // TODO Shit's fucked
    }

}
